import React from 'react';
import Icon from '../../../components/AppIcon';

const ContractDeadlineCard = ({ deadline }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })?.format(date);
  };

  const getUrgencyColor = (daysRemaining) => {
    if (daysRemaining < 0) {
      return {
        bg: 'bg-error/10',
        text: 'text-error',
        border: 'border-error/20',
        icon: 'AlertCircle'
      };
    } else if (daysRemaining <= 7) {
      return {
        bg: 'bg-error/10',
        text: 'text-error',
        border: 'border-error/20',
        icon: 'AlertTriangle'
      };
    } else if (daysRemaining <= 30) {
      return {
        bg: 'bg-warning/10',
        text: 'text-warning',
        border: 'border-warning/20',
        icon: 'Clock'
      };
    } else {
      return {
        bg: 'bg-success/10',
        text: 'text-success',
        border: 'border-success/20',
        icon: 'CheckCircle'
      };
    }
  };

  const urgency = getUrgencyColor(deadline?.daysRemaining);

  const getStatusLabel = (daysRemaining) => {
    if (daysRemaining < 0) return 'منتهي';
    if (daysRemaining === 0) return 'ينتهي اليوم';
    if (daysRemaining === 1) return 'ينتهي غداً';
    return `${daysRemaining} يوم متبقي`;
  };

  return (
    <div className={`bg-card rounded-lg border ${urgency?.border} p-4 hover:shadow-warm transition-all duration-250`} dir="rtl">
      <div className="flex items-start gap-3">
        <div className={`w-12 h-12 rounded-full ${urgency?.bg} flex items-center justify-center flex-shrink-0`}>
          <Icon name={urgency?.icon} size={20} color={`var(--color-${urgency?.text?.replace('text-', '')})`} />
        </div>
        
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-foreground">{deadline?.contractNumber}</h4>
            <span className={`px-2 py-0.5 rounded text-xs font-semibold ${urgency?.bg} ${urgency?.text}`}>
              {deadline?.contractType}
            </span>
          </div>
          
          <p className="text-sm text-muted-foreground mb-2 line-clamp-1">
            {deadline?.propertyTitle}
          </p>

          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-muted-foreground mb-1">تاريخ الانتهاء</p>
              <p className="text-sm font-medium text-foreground">{formatDate(deadline?.endDate)}</p>
            </div>
            
            <div className="text-left">
              <p className={`text-2xl font-bold ${urgency?.text}`}>
                {Math.abs(deadline?.daysRemaining)}
              </p>
              <p className={`text-xs ${urgency?.text}`}>
                {getStatusLabel(deadline?.daysRemaining)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      {deadline?.daysRemaining >= 0 && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div 
              className={`h-full ${urgency?.text?.replace('text-', 'bg-')} transition-all duration-500`}
              style={{ 
                width: `${Math.max(0, Math.min(100, (deadline?.daysRemaining / 90) * 100))}%` 
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractDeadlineCard;